import { createSlideIcon, type IconProps } from '../SlideTypeIcon';
const DEFAULT_COLOR = 'var(--palette-yellow-700)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M19 19H15L13 5H19V19Z" fill={textColor} />
    <path d="M11 19H7L5 5H11V19Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M23.04 23.0401H19.76L16.48 8.64014H23.04V23.0401Z"
      fill={textColor}
    />
    <path
      d="M15.36 23.0401H12.08L8.80005 8.64014H15.36V23.0401Z"
      fill={textColor}
    />
  </>
);

export const QuoteIcon = createSlideIcon(Icon24x24, Icon32x32);
